var map = {
	"./Vector.svg": 80517,
	"./active-client.svg": 50103,
	"./add.svg": 83232,
	"./additionalAccountFilters.svg": 10603,
	"./addСircle.svg": 67176,
	"./advancedFilter.svg": 64708,
	"./apps.svg": 67532,
	"./archive.svg": 43473,
	"./arrow-left-alt.svg": 9295,
	"./arrow-left.svg": 74321,
	"./arrow-right-alt.svg": 82943,
	"./arrow-right.svg": 24369,
	"./arrowDown.svg": 49451,
	"./arrowForward.svg": 30493,
	"./arrowUp.svg": 83048,
	"./ascending.svg": 43266,
	"./attachFile.svg": 76316,
	"./build.svg": 80825,
	"./charmFilter.svg": 84259,
	"./chart-placeholder.svg": 5765,
	"./chevronDown.svg": 24920,
	"./chevronLeft.svg": 17217,
	"./chevronRight.svg": 72101,
	"./chevronUp.svg": 18816,
	"./circleAdd.svg": 49423,
	"./circleRemove.svg": 78665,
	"./clarityFilterGridLine.svg": 56375,
	"./clear.svg": 93763,
	"./clearSmall.svg": 22625,
	"./column-settings.svg": 56022,
	"./copy-settings.svg": 15900,
	"./create.svg": 37561,
	"./crop.svg": 25528,
	"./delete.svg": 32284,
	"./descending.svg": 53981,
	"./description.svg": 95565,
	"./done.svg": 1462,
	"./doneSmall.svg": 23657,
	"./dragSortArrows.svg": 43650,
	"./dragnDrop.svg": 31941,
	"./elastic.svg": 75461,
	"./emptyAvatar.svg": 69317,
	"./expand-query.svg": 392,
	"./expand.svg": 97914,
	"./fast-choose-period.svg": 15551,
	"./favorite.svg": 57939,
	"./filterNone.svg": 71297,
	"./filterNoneSmall.svg": 65528,
	"./flex-alignContent-center.svg": 892,
	"./flex-alignContent-flex-end.svg": 60160,
	"./flex-alignContent-flex-start.svg": 658,
	"./flex-alignContent-space-around.svg": 41500,
	"./flex-alignContent-space-between.svg": 95833,
	"./flex-alignContent-stretch.svg": 75925,
	"./flex-alignItems-baseline.svg": 21793,
	"./flex-alignItems-center.svg": 86531,
	"./flex-alignItems-flex-end.svg": 20964,
	"./flex-alignItems-flex-start.svg": 81566,
	"./flex-alignItems-stretch.svg": 98411,
	"./flex-flexDirection-column-reverse.svg": 10530,
	"./flex-flexDirection-column.svg": 33490,
	"./flex-flexDirection-row-reverse.svg": 76900,
	"./flex-flexDirection-row.svg": 3837,
	"./flex-flexWrap-nowrap.svg": 57529,
	"./flex-flexWrap-wrap.svg": 8866,
	"./flex-justifyContent-center.svg": 61826,
	"./flex-justifyContent-flex-end.svg": 97992,
	"./flex-justifyContent-flex-start.svg": 32231,
	"./flex-justifyContent-space-around.svg": 50717,
	"./flex-justifyContent-space-between.svg": 53056,
	"./flex-justifyContent-space-evenly.svg": 66162,
	"./gTranslate.svg": 89868,
	"./grade.svg": 56674,
	"./hasReports.svg": 22595,
	"./height.svg": 8742,
	"./help.svg": 47754,
	"./helpOutline.svg": 46701,
	"./home.svg": 88240,
	"./horizontalMenu.svg": 94482,
	"./icon.svg": 14992,
	"./imageSearch.svg": 42582,
	"./info.svg": 14013,
	"./inputNumberArrowDown.svg": 47099,
	"./inputNumberArrowUp.svg": 61188,
	"./insertComment.svg": 15484,
	"./launch.svg": 60781,
	"./locker.svg": 75541,
	"./metric-text.svg": 43631,
	"./mic.svg": 36051,
	"./micOff.svg": 76826,
	"./minus.svg": 2698,
	"./modify-sausage.svg": 24391,
	"./modify.svg": 344,
	"./na.svg": 75009,
	"./navigateBefore.svg": 58867,
	"./noise.svg": 15586,
	"./notSeen.svg": 17498,
	"./notifications.svg": 90748,
	"./open.svg": 13315,
	"./pause.svg": 79250,
	"./pauseCircleFilled.svg": 54596,
	"./permCameraMic.svg": 93949,
	"./play.svg": 78822,
	"./playArrow.svg": 16720,
	"./playCircleFilled.svg": 32635,
	"./playCircleOutline.svg": 41242,
	"./playNext.svg": 85471,
	"./playNextDoubleStep.svg": 85255,
	"./playNextStep.svg": 65941,
	"./plus.svg": 38495,
	"./profile.svg": 48023,
	"./progress.svg": 48271,
	"./project-type-chat.svg": 49516,
	"./project-type-device_audio.svg": 9960,
	"./project-type-ingest.svg": 25140,
	"./project-type-multichat.svg": 54676,
	"./publish.svg": 78597,
	"./recordVoiceOver.svg": 49685,
	"./refresh-rotated.svg": 74461,
	"./refresh.svg": 7686,
	"./remove.svg": 94325,
	"./removeCircle.svg": 50693,
	"./replay.svg": 31677,
	"./restore.svg": 85273,
	"./row-in-cell.svg": 14941,
	"./saveAlt.svg": 55108,
	"./search.svg": 2198,
	"./seen.svg": 87035,
	"./send.svg": 58731,
	"./sentiment-client-negative.svg": 84217,
	"./sentiment-client-neutral.svg": 33910,
	"./sentiment-client-positive.svg": 24226,
	"./sentiment-operator-negative.svg": 39544,
	"./sentiment-operator-neutral.svg": 79105,
	"./sentiment-operator-positive.svg": 26982,
	"./settings.svg": 94389,
	"./settingsBackupRestore.svg": 31543,
	"./settingsPhone.svg": 36587,
	"./share.svg": 35917,
	"./sidebar_monitoring.svg": 97239,
	"./sidebar_speakers.svg": 97293,
	"./simple-pause.svg": 49994,
	"./simple-play.svg": 56510,
	"./skipNext.svg": 48,
	"./skipPrevious.svg": 53205,
	"./sortArrowDown.svg": 16278,
	"./sortArrowUp.svg": 30913,
	"./stop.svg": 60528,
	"./swapHoriz.svg": 98326,
	"./textFields.svg": 8454,
	"./toolbar_queries.svg": 65773,
	"./tune.svg": 45330,
	"./unactive-client.svg": 29324,
	"./unarchive.svg": 40738,
	"./viewList.svg": 34311,
	"./viewStream.svg": 28251,
	"./visibility.svg": 7512,
	"./visibilityOff.svg": 92126,
	"./volume.svg": 6349,
	"./volumeUp.svg": 97853,
	"./warning.svg": 44326,
	"./zoomIn.svg": 67309,
	"./zoomOut.svg": 11637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88091;